export default {"src":"/_next/static/media/icon-content-protection.99122ae8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};